import { render } from "./PopupOrdinamento.vue?vue&type=template&id=7ffe58ea"
import script from "./PopupOrdinamento.vue?vue&type=script&lang=js"
export * from "./PopupOrdinamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__